// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sg-menu-item[data-v-aca35712] {\n  padding: 5px 10px;\n  line-height: 24px;\n  color: #666;\n}\n.sg-menu-item[data-v-aca35712]:hover {\n  background-color: #f2f4f5;\n}", ""]);
// Exports
module.exports = exports;
